module.exports = function() {
  return new Worker(__webpack_public_path__ + "376f092adf7846a1ee97.worker.js");
};